<script>
	import { signUp } from "../scripts/auth";
    import { push } from "svelte-spa-router";
    import * as EmailValidator from 'email-validator';
    import SuccessAlert from "../components/SuccessAlert.svelte";

    let email = "";
    let password = "", passwordAgain = "";
    let emailInput, passwordInput, passwordAgainInput;

    let passwordError = "", emailError = "", submitError = "";
    let loading = false;
    let showSuccess = false;

    function validateEmail() {
        if(email.length < 1) {
            setEmailError("Sähköposti on pakollinen");
            return;
        }
        const result = EmailValidator.validate(email);
        if(result) { 
            clearEmailError();
            setEmailSuccess();
        }
        else {
            setEmailError("Sähköpostin muoto on väärä");
        }
    }

    function validatePassword() {
        if(password.length < 8) setErrors("Salanan tulee olla vähintään 8 merkkiä pitkä");
        else if(password !== passwordAgain) setErrors("Salasanat eivät täsmää");
        else { 
            clearErrors();
            setSuccess();
        }
    }

    function setEmailError(msg) {
        emailError = msg;
        emailInput.classList.add("input-error");
    }

    function clearEmailError() {
        emailError = "";
        emailInput.classList.remove("input-error");
    }

    function setEmailSuccess() {
        emailInput.classList.add("input-success");
    }

    function setErrors(msg) {
        passwordInput.classList.add("input-error");
        passwordAgainInput.classList.add("input-error");
        passwordError = msg;
    }

    function clearErrors() {
        passwordError = "";
        passwordInput.classList.remove("input-error");
        passwordAgainInput.classList.remove("input-error");
    }

    function setSuccess() {
        passwordInput.classList.add("input-success");
        passwordAgainInput.classList.add("input-success");
    }

    async function onSubmit() {
        loading = true;
        
        const { error } = await signUp(email, password);
        
        if(error) submitError = error;
        else showSuccess = true;

        loading = false;

        setTimeout(() => {
            showSuccess = false;
            push("add-user-info");
        }, 1500)
    }
    
</script>

<style>
    .form-container {
        margin-top: 2rem;
    }
    .hint {
        color: gray;
        font-size: .8rem;
        max-width: 320px;
    }
    .margin-y {
        margin-top: 1.5rem;
    }
    .error {
        color: red;
        font-size: .8rem;
        max-width: 320px;
    }
    .inp::after {
        content: "moi";
        position: absolute;
        transform: translate(100%, 100%);
    }
</style>

<div class="container">
    <div class="content-container">
        <h1>Luo käyttäjä</h1>

        <div class="form-container">
            <label class="label" for="email">Sähköpostiosoite</label>
            <input type="text" id="email" placeholder="username@example.com" 
             class="input input-bordered input-primary w-full max-w-xs inp"
             bind:this={ emailInput }
             bind:value={ email }
             on:blur={ validateEmail }
             on:focus={ clearEmailError }
            >

            {#if emailError}<p class="error">{ emailError }</p>{/if}

            <label class="label" for="password">Salasana</label>
            <input type="password" id="password" placeholder="**********" 
             class="input input-bordered input-primary w-full max-w-xs"
             bind:this={ passwordInput }
             bind:value={ password }
             on:focus={ clearErrors }
            >
            <p class="hint">
                Salasanan tulee olla vähintään 8 merkkiä pitkä
            </p>

            <label class="label" for="passwordAgain">Salasana uudelleen</label>
            <input type="password" id="passwordAgain" placeholder="**********" 
             class="input input-bordered input-primary w-full max-w-xs"
             bind:this={ passwordAgainInput }
             bind:value={ passwordAgain } 
             on:blur={ validatePassword }
            >

            {#if passwordError}<p class="error">{ passwordError }</p>{/if}
            {#if submitError}<p class="error">{ submitError }</p>{/if}
            <br />

            <button class="btn btn-primary margin-y {loading ? "loading" : ""}" 
             disabled={ emailError || passwordError }
             on:click={ onSubmit }
            >
                Luo käyttäjä
            </button>
        </div>

    </div>
</div>

<SuccessAlert open={ showSuccess } message="Käyttätunnuksen luominen onnistui!" />